import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MuxPlayerOverlay from "../components/Talktape/MuxPlayerOverlay";

const TalkTapePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [open, setOpen] = useState(true);

  const [talktapeData, setTalktapeData] = useState<any>(null);
  const [errorContent, setErrorContent] = useState<string | null>(null);

  useEffect(() => {
    if ( !id ) return;
    fetch(`${import.meta.env.VITE_API_URL}/talktape/${id}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error("Failed to fetch talktape data");
      }
      return res.json();
    })
    .then((jsondata) => { 
      setTalktapeData(jsondata.data); 
      console.log("Fetched talktape data:", jsondata.data);
    })
    .catch((err) => setErrorContent(err instanceof Error ? err.message : "An unknown error occurred"));
  }, [id]);

  return (
    <div style={{ backgroundColor: "#000", minHeight: "100vh" }}>
      {errorContent && (
        <div style={{ color: "red", textAlign: "center", paddingTop: "20px" }}>
          Video not found or unavailable.
        </div>
      )}
      {talktapeData?.mux_playback_id && (
        <MuxPlayerOverlay
          open={open}
          onClose={() => setOpen(false)}
          mux_playback_id={talktapeData.mux_playback_id}
          talktape_video_title={talktapeData.talktape_video_title}
        />
      )}
    </div>
  );
};

export default TalkTapePage;